import { routesBuilder } from '@guiker/api-definition'

import { ListingInquiry } from '../../../../entity'
import { paths } from '../../paths'
import { completeListingInquirySchema, updateQualificationSchema } from './schemas'

const { buildPut } = routesBuilder<ListingInquiry>()({
  basePath: paths.listingInquiry.all.withId(),
})

export const routes = {
  qualifyListingInquiry: buildPut({
    path: '/qualify',
    payloadSchema: updateQualificationSchema,
  }),
  completeListingInquiry: buildPut({
    path: '/complete',
    payloadSchema: completeListingInquirySchema,
  }),
}
